import React, { useState, useEffect, useRef } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faEraser } from '@fortawesome/free-solid-svg-icons';
import { IconButton } from '@material-ui/core';

import './EraserWidthButton.css'

const EraserWidthButton = ({ onSelectWidth }) => {
  const [isEraserWidthOpen, setIsEraserWidthOpen] = useState(false);
  const [selectedWidth, setSelectedWidth] = useState(3);
  const eraserWidthRef = useRef(null);

  const handleWidthSelect = (width, event) => {
    setSelectedWidth(width);
    onSelectWidth(width);
    setIsEraserWidthOpen(false);
    event.stopPropagation();
  };

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (eraserWidthRef.current && !eraserWidthRef.current.contains(event.target)) {
        setIsEraserWidthOpen(false);
      }
    };
    
    document.addEventListener('mousedown', handleClickOutside);

    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, [eraserWidthRef]);

  return (
    <div className="eraser-width-button">
      <IconButton 
        onClick={() => setIsEraserWidthOpen(!isEraserWidthOpen)}
        title="Eraser Size"
      >
        <FontAwesomeIcon icon={faEraser} />
      </IconButton>

      {isEraserWidthOpen && (
        <div className="eraser-width-button__dropdown" ref={eraserWidthRef}>
          <div className="eraser-width-button__label">Eraser Size</div>
          <div className="eraser-width-button__widths">
            <div
              className={`eraser-width-button__width eraser-width-button__width--5 ${selectedWidth === 5 ? 'active' : ''}`}
              onClick={(e) => handleWidthSelect(5, e)}
              title="Small"
            ></div>
            <div
              className={`eraser-width-button__width eraser-width-button__width--10 ${selectedWidth === 10 ? 'active' : ''}`}
              onClick={(e) => handleWidthSelect(10, e)}
              title="Medium"
            ></div>
            <div
              className={`eraser-width-button__width eraser-width-button__width--15 ${selectedWidth === 15 ? 'active' : ''}`}
              onClick={(e) => handleWidthSelect(15, e)}
              title="Large"
            ></div>
            <div
              className={`eraser-width-button__width eraser-width-button__width--25 ${selectedWidth === 25 ? 'active' : ''}`}
              onClick={(e) => handleWidthSelect(25, e)}
              title="Extra Large"
            ></div>
          </div>
        </div>
      )}
    </div>
  );
};

export default EraserWidthButton;
